import { Button } from '@sr/ui-library';

type RefreshPageButtonProps = {
  className?: string;
  onClick?: () => void;
};

/**
 * Inline "refreshing" link used in error copy (ErrorPage / ANZ in-card errors).
 * Defaults to a full page reload; pass `onClick` for a soft retry.
 */
export const RefreshPageButton = ({
  className = 'btn-link-inline p-0 text-sm font-semibold text-inherit underline',
  onClick,
}: RefreshPageButtonProps) => (
  <Button
    className={className}
    type="button"
    variant="link"
    onClick={onClick ?? (() => window.location.reload())}
  >
    refreshing
  </Button>
);
